import ContentDialogState from "./ContentDialogState";

export type ContentDialogActionTypes = "SET_CONTENT_DIALOG";

export const ContentDialogActionTypes = {
  SET_CONTENT_DIALOG: "SET_CONTENT_DIALOG" as ContentDialogActionTypes,
};

export interface SetContentDialogAction {
  type: typeof ContentDialogActionTypes.SET_CONTENT_DIALOG;
  data: ContentDialogState;
}

export type ContentDialogActions = SetContentDialogAction;